export default "__VITE_ASSET__Ke4rSCb9__"